import { jsx as _jsx } from "preact/jsx-runtime";
/* eslint-disable @typescript-eslint/naming-convention,react/no-danger */
import DOMPurify from 'dompurify';
export default function ContentBlock(props) {
    const { content } = props;
    return (_jsx("div", { className: "form__content content-block", dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(content) } }));
}
